import Pristine from 'pristinejs';
import { load } from 'recaptcha-v3';
import axios from 'axios';
import { showExpandable, hideExpandable } from '../../../../assets/src/js/common/expandable';

import '../sass/citrus-book-a-valuation.scss';

(() => {
    const $citrusBookAValuations = document.querySelectorAll('.citrus-book-a-valuation');

    if (!$citrusBookAValuations) return;

    const { RECAPTCHA_V3_SITE_KEY } = GLOBALS;

    $citrusBookAValuations.forEach($citrusBookAValuation => {
        const $form = $citrusBookAValuation.querySelector('.citrus-book-a-valuation__form');

        const $postcodeSearch = $citrusBookAValuation.querySelector('.citrus-book-a-valuation__postcode-search');
        const $postcodeSearchInput = $citrusBookAValuation?.querySelector('.citrus-book-a-valuation__postcode-search-input input');
        const $postcodeSearchResults = $citrusBookAValuation?.querySelector('.citrus-book-a-valuation__postcode-search-results');
        const $postcodeSearchResultsList = $citrusBookAValuation?.querySelector('.citrus-book-a-valuation__postcode-search-results-list');
        const $postcodeSearchManual = $citrusBookAValuation?.querySelector('.citrus-book-a-valuation__postcode-search-manual');
        const $postcodeSearchManualBtn = $citrusBookAValuation?.querySelector('.citrus-book-a-valuation__postcode-search-manual-btn');

        const $addressResults = $citrusBookAValuation.querySelector('.citrus-book-a-valuation__address-results');
        const $formAddressLine1Input = $citrusBookAValuation?.querySelector('.citrus-book-a-valuation__form-address-line-1-input input');
        const $formAddressLine2Input = $citrusBookAValuation?.querySelector('.citrus-book-a-valuation__form-address-line-2-input input');
        const $formCityInput = $citrusBookAValuation?.querySelector('.citrus-book-a-valuation__form-city-input input');
        const $formRegionInput = $citrusBookAValuation?.querySelector('.citrus-book-a-valuation__form-region-input input');
        const $formPostcodeInput = $citrusBookAValuation?.querySelector('.citrus-book-a-valuation__form-postcode-input input');
        const $formCountryInput = $citrusBookAValuation?.querySelector('.citrus-book-a-valuation__form-country-input input');

        const initFormValidation = () => {
            if (!$form) return;

            const pristine = new Pristine($form);
        
            $form.addEventListener('submit', e => {
                e.preventDefault();

                if ($form.classList.contains('citrus-book-a-valuation__form--loading')) {
                    return;
                }

                $form.classList.add('citrus-book-a-valuation__form--loading');

                if ($addressResults) {
                    showExpandable($addressResults);
                }

                if ($postcodeSearchManual) {
                    hideExpandable($postcodeSearchManual);
                }

                if (!pristine.validate()) {
                    $form.classList.remove('citrus-book-a-valuation__form--loading');

                    return;
                }

                const $recaptchaTokenInput = $form.querySelector('.recaptcha-token');

                if (RECAPTCHA_V3_SITE_KEY && $recaptchaTokenInput) {
                    load(RECAPTCHA_V3_SITE_KEY).then((recaptcha) => {
                        recaptcha.execute('book_a_valuation').then((token) => {
                            $recaptchaTokenInput.value = token;

                            $form.submit();
                        });
                    });
                } else {
                    $form.submit();
                }
            });
        };

        const initPostcodeSearch = () => {
            if (!$postcodeSearch || !$addressResults || !$postcodeSearchInput || !$postcodeSearchResults || !$postcodeSearchResultsList) return;

            const postcodeSearchController = new AbortController();

            $postcodeSearchInput.addEventListener('keydown', e => {
                if (e.key === 'Enter' || e.keyCode === 13) {
                    e.preventDefault();
                }
            });

            $postcodeSearchInput.addEventListener('keyup', () => {
                if (!$postcodeSearchInput?.value) return;
                
                const { nonce } = $postcodeSearchInput?.dataset;

                axios.get(GLOBALS.AJAX_URL, {
                    params: {
                        action: 'citrus_property_ajax_search_postcode', 
                        nonce,
                        postcode: $postcodeSearchInput.value
                    },
                    signal: postcodeSearchController.signal
                }).then(response => {
                    if (!response?.data?.success) {
                        hideExpandable($postcodeSearchResults);
                    }

                    if (response?.data?.success) {
                        $postcodeSearchResultsList.innerHTML = '';

                        if (response?.data?.postcodes?.addresses) {
                            response.data.postcodes.addresses.forEach(address => {
                                $postcodeSearchResultsList.insertAdjacentHTML('beforeend', `
                                    <li>
                                        <button class="citrus-book-a-valuation__postcode-search-btn background-color-transparent font-size-14
                                                hover-background-color-blue hover-color-white"
                                            type="button"
                                            data-address-line-1="${address?.formatted_address?.[0]}"
                                            data-address-line-2="${address?.formatted_address?.[1]}"
                                            data-city="${address?.formatted_address?.[3]}"
                                            data-region="${address?.formatted_address?.[4]}"
                                            data-postcode="${response.data.postcodes.postcode}"
                                            aria-controls="${$addressResults?.id}">

                                            ${address?.formatted_address?.filter(addressPart => addressPart !== '').join(', ')}
                                        </button>
                                    </li>
                                `);
                            });

                            const $postcodeSearchBtns = $postcodeSearchResultsList.querySelectorAll('.citrus-book-a-valuation__postcode-search-btn');

                            if ($postcodeSearchBtns) {
                                $postcodeSearchBtns.forEach($postcodeSearchBtn => {
                                    $postcodeSearchBtn.addEventListener('click', () => {
                                        $formAddressLine1Input.value = $postcodeSearchBtn?.dataset['addressLine-1'];
                                        $formAddressLine2Input.value = $postcodeSearchBtn?.dataset['addressLine-2'];
                                        $formCityInput.value = $postcodeSearchBtn?.dataset['city'];
                                        $formRegionInput.value = $postcodeSearchBtn?.dataset['region'];
                                        $formPostcodeInput.value = $postcodeSearchBtn?.dataset['postcode'];

                                        $postcodeSearchInput.value = '';

                                        showExpandable($addressResults);
                                        hideExpandable($postcodeSearchManual);
                                        hideExpandable($postcodeSearchResults);
                                    });
                                });
                            }

                            showExpandable($postcodeSearchResults);
                        }
                    }
                }).catch(thrown => {
                    console.log(thrown);

                    hideExpandable($postcodeSearchResults);
                }).finally(() => {
                });
            });

            if ($postcodeSearchManualBtn) {
                $postcodeSearchManualBtn.addEventListener('click', () => {
                    hideExpandable($postcodeSearchResults);

                    showExpandable($addressResults);
                    hideExpandable($postcodeSearchManual);

                    $postcodeSearchInput.value = '';
                });
            }
        };

        initFormValidation();
        initPostcodeSearch();
    });
})();
